import { FormBeforeSendError } from './FormBeforeSendError';

export class FormBeforeSendNoChangesError extends FormBeforeSendError {
  constructor(message = 'No changes') {
    super(message);

    this.code = 'no_changed_data';
  }
}
